import React, {createContext, useContext} from 'react';

import {ListController, ListSelectMode, ListValue} from '../list';

export type DropDownContextValue = {
	open: boolean;
	setOpen(open: boolean, event?: React.SyntheticEvent): void;
	toggle(event: React.SyntheticEvent): void;
	disabled?: boolean;
	selectMode?: ListSelectMode;
	/** выделенные значения; пусто, когда выделение не используется */
	selected: ListValue[];
	select(values: ListValue[], event: React.SyntheticEvent): void;
	/** текст в поле ввода триггера; undefined, когда ввода нет */
	inputValue?: string;
	setInputValue(value: string, event: React.SyntheticEvent): void;
	triggerRef: React.RefObject<HTMLElement | null>;
	dropdownRef: React.RefObject<HTMLDivElement | null>;
	dropdownId: string;
	/** переводит фокус на первый пункт выпадашки */
	focusFirstItem(): void;
	/** фокус остаётся в триггере, по списку ходит виртуальный фокус */
	virtualFocus: boolean;
	listController: React.RefObject<ListController | null>;
	/** id активного пункта для aria-activedescendant */
	activeDescendant?: string;
	setActiveDescendant(id: string | undefined): void;
};

export const DropDownContext = createContext<DropDownContextValue | null>(null);

export const useDropDownContext = () => useContext(DropDownContext);
